import { InstanceScreen } from 'component/navigation/instance';

export default function EditorialDashboardSpacesScreen() {
    return <InstanceScreen screenKey='spaces' />;
}
